import type { HTMLAttributes } from 'react';

import { GhostButton, classNames } from '@movingimage-evp/mi-ui-component-library';
import { useTranslation } from 'react-i18next';

import styles from './list-items-pagination.module.css';

type ListItemsPaginationProps = {
  current: number;
  total: number;
  onShowMore: () => void;
} & HTMLAttributes<HTMLDivElement>;

export function ListItemsPagination({ current, total, className, onShowMore, ...props }: ListItemsPaginationProps) {
  const { t } = useTranslation();
  if (current >= total) return null;

  return (
    <div data-testid="list-items-pagination" className={classNames(styles.wrapper, className)} {...props}>
      <small data-testid="list-items-pagination-info">
        {t('components.listItemsPagination.info', { current, total })}
      </small>

      <GhostButton data-testid="list-items-pagination-button" type="button" small onClick={onShowMore}>
        {t('components.listItemsPagination.button')}
      </GhostButton>
    </div>
  );
}
